import React from 'react';
import { withRouter } from "react-router-dom";
import EbinderLanding from '../EBinderComponent/EbinderLandingPage.component';


const EbinderMainLanding = (props) => {
    return <EbinderLanding setRecentSearch={props.setRecentSearch} recentSearch={props.recentSearch} loggedUserInfo={props.loggedUserInfo} userId={props.userId} clientId={props.clientId}  setSearchCompany={props.setSearchCompany} searchCompany={props.searchCompany}/>
}
export default withRouter(EbinderMainLanding);